<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="a"
                :pages="[
                    {
                        name: $tc('messages.syllabus_contents', 2),
                        href: meta.links.index,
                    },
                    {
                        name: $t('messages.edit'),
                        href: null,
                    },
                ]"
            />
        </template>

        <div class="relative inline-block text-left">
            <div class="mt-1">
                <FormLabel :value="$t('messages.title')" for="title" />
                <FormTextarea
                    required
                    id="title"
                    v-model="form.title"
                    name="title"
                    type="text"
                    max="500"
                    class="mt-1 w-full"
                />
                <FormError :value="form.errors.title" class="mt-2" />
            </div>

            <div class="sm:col-span-4">
                <div class="mt-1">
                    <FormLabel :value="$t('messages.grade_level')" for="grade_level_id" />
                    <div>
                        <label class="ml-1 mr-3" v-for="gradeLevel in options.gradeLevels" :key="gradeLevel.value">
                            <input
                                :id="`grade_level_ids_${gradeLevel.value}`"
                                name="grade_level_ids[]"
                                :value="gradeLevel.value"
                                type="checkbox"
                                v-model="form.grade_level_ids"
                                class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                            />
                            {{ gradeLevel.text }}
                        </label>

                        <FormError :value="form.errors.grade_level_ids" class="mt-2" />
                    </div>
                </div>
            </div>

            <div class="sm:col-span-4">
                <div class="mt-1">
                    <FormLabel :value="$tc('messages.domains', 1)" for="category_id" />
                    <FormSelect
                        required
                        id="category"
                        v-model.number="form.category_id"
                        :options="options.categories"
                        class="mt-1 w-full"
                        property-name="name"
                        property-value="id"
                    />

                    <FormError :value="form.errors.category_id" class="mt-2" />
                </div>
            </div>

            <div class="sm:col-span-4">
                <div class="mt-1">
                    <FormLabel :value="$tc('messages.competences', 2)" for="competences" />
                    <FormError :value="form.errors.competences_ids" class="mt-2" />
                    <div v-if="selectedCategory !== null">
                        <div class="sm:col-span-1" v-for="dimension in selectedCategory.dimensions" :key="dimension.id">
                            <label class="block text-sm font-medium leading-5 text-gray-700">
                                {{ dimension.abbreviation }} -
                                {{ dimension.title }}
                            </label>
                            <ul class="m-3">
                                <li
                                    v-for="(competence, competenceIndex) in dimension.competences"
                                    :key="`competence_${competence.id}`"
                                    :class="{
                                        'bg-gray-100': competenceIndex % 2 === 0,
                                    }"
                                >
                                    {{ competence.abbreviation }} -

                                    <input
                                        :id="`competences_ids_${competence.id}`"
                                        name="competences_ids[]"
                                        :value="competence.id"
                                        type="checkbox"
                                        v-model="form.competences_ids"
                                        class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                                    />
                                    <div class="text-sm inline-block">
                                        {{ competence.description }}
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <form action="" method="post" @submit.prevent="submit" class="mt-5">
                <div class="flex justify-end">
                    <SubmitFormButton :button-text="$t('messages.save')" :processing="form.processing" />
                </div>
            </form>
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormError from '@/components/Forms/FormError.vue';
import FormSelect from '@/components/Forms/FormSelect.vue';
import FormTextarea from '@/components/Forms/FormTextarea.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';

export default {
    components: {
        SubmitFormButton,
        FormTextarea,
        PanelPage,
        FormLabel,
        FormError,
        FormSelect,
    },
    layout: Layout,
    name: 'Edit',
    props: ['teacher', 'meta', 'options', 'syllabus_content'],
    data() {
        return {
            form: this.$inertia.form({
                title: this.syllabus_content.title,
                category_id: this.syllabus_content.category_id,
                grade_level_ids: this.syllabus_content.grade_level_ids,
                competences_ids: this.syllabus_content.competences_ids,
            }),
        };
    },
    computed: {
        selectedCategory: function () {
            if (!this.form.category_id) {
                return null;
            }

            return this.options.categories.find((c) => c.id === this.form.category_id);
        },
    },
    watch: {
        'form.category_id': {
            handler() {
                this.form.competences_ids = [];
            },
            deep: true,
        },
    },
    methods: {
        submit() {
            this.form.patch(this.meta.links.update);
        },
    },
};
</script>
